<template>
  <div class="szbj-container">
    <Layout title="数字镖局" :content="content" :imgsrc="Imgsrc" >
      <template>
        <div class="video-box">
          <div class="video">
            <video ref="video" src=" 
            https://video.wezhan.cn/d0bedd113f6071efaf686732b78e0102/54ef96935f25423d9b632afcceeff6b2-6691935feffdcdecd044d33f2ac422a1-sd.mp4?auth_key=1720686759-69fab1c3a7e748d084ef285a6b1563d2-0-5a871488364fa949fe1370fa944b4321
            " poster="../../assets/数字镖局bj.jpg" :controls="!isPlay"></video>
            <div class="video-btn" @click="handclick" v-if="isPlay">
              <i class="iconfont icon-bofang"></i>
            </div>
          </div>
          <div class="video-content">
            <div class="title-list">
              <p class="title">视频详情</p>
              <p class="content">查看视频了解详细安装使用教程</p>
            </div>
            <div class="btn-list">
              <span class="download" @click="download">下载使用</span>
              <span class="look" @click="handclick">查看使用教程</span>
            </div>
          </div>
        </div>
      </template>
    </Layout>
    <div class="szbj-body">
      <div class="hxcp">
        <div class="hxcp-title">三大核心亮点</div>
        <div class="products-List">
          <div class="product-item">
            <img class="Img" src="../../assets1/数字镖局_slices/位图.png" alt="">
            <p class="item-title">数据保险箱</p>
            <p class="item-content">
              数字镖局的每一个用户都拥有其专属的数据保险箱, 并会生产其专属的密钥. 仅用户本人及其授权的用户才能查看.
            </p>
          </div>
          <div class="product-item">
           <img class="Img" src="../../assets1/数字镖局_slices/位图(1).png" alt="">
            <p class="item-title">可信传输通道</p>
            <p class="item-content">
              数据的传输将在发送方与接收方之间建立“端对端”的加密通信网络, 用于密文数据的传输, 传输全过程无第三方参与, 第三方无法截取数据明文.
            </p>
          </div>
          <div class="product-item">
           <img class="Img" src="../../assets1/数字镖局_slices/位图(2).png" alt="">
            <p class="item-title">数字U盾</p>
            <p class="item-content">
              数字镖局自研硬件级安全方案——数字U盾,数据加解密的密钥, 均保存在脱网离线的安全芯片中, 最大程度保障您的数据安全.
            </p>
          </div>
        </div>
      </div>

      <div class="szbj-introduce">
        <div class="introduce-list">
          <div class="list-item" v-for="(it,index) in data" :key="index " :style="{'backgroundImage':'url(' + it.img + ')'}">
            <div class="item-Content" :class="[it.type==='left'?'leftActive':'rightActive']" >
              <div class="Content-head" >
                <img :src="it.icon" alt="">
                <p>{{it.title}}</p>
              </div>
              <div class="Conten-body">
                <p>
                 {{it.content}}
                </p>
                <p v-if="it.content2">
                     {{it.content2}}
                </p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";

import imgSrc from "@/assets1/数字镖局_slices/关于我们banner.png"
// import imgSrc1 from "@/assets1/数字镖局_slices/租住.png"
// import imgSrc2 from "@/assets1/数字镖局_slices/医疗.png"
// import imgSrc3 from "@/assets1/数字镖局_slices/供应.png"
import icon1 from "@/assets1/数字镖局_slices/租住行业.png"
import icon2 from "@/assets1/数字镖局_slices/医疗行业.png"
import icon3 from "@/assets1/数字镖局_slices/供应链.png"
export default {
  components: {
    Layout,
  },
  computed:{
   
  },
  data(){
    return{
        data:[{title:'专属安全空间',
        content:'数字镖局为每一个用户提供其专属的安全存储空间, 用户的数据在上传前, 会使用其专属的密钥进行加密. 加密后的数据将上传至数字镖局的保险箱中, 仅用户本人及其授权的用户才能查看.'
        ,  img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E7%A7%9F%E4%BD%8F.png',
        icon:icon1,
        type:'right'
        },
        {title:'数据授权分享',
        content:'用户可以将上传后的数据分享给指定的用户, 数字镖局会将分享者数据保险箱中的数据重新“包装”成被分享者可解密的数据, 该环节采用隐私加密计算技术, 确保在“包装”过程中明文数据无法被数字镖局自身和无关第三方读取, 整个计算过程可在事后核验其合法性.'
        ,  img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%8C%BB%E7%96%97.png',icon:icon2,
        type:'left'
        },
        {title:'区块链存证',
        content:'用户将本地文件(数据)上传至数字镖局, 上传的数据会通过数字镖局的区块链进行产权登记, 保护用户数据的权益.',
        content2:'数字镖局可以通过区块链技术实现数据资产的标准化, 建立统一的数据字典, 形成基于区块链的数据图谱.'
        ,  img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E4%BE%9B%E5%BA%94.png',icon:icon3,
        type:'right'
        }
        ],
        Imgsrc:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%AD%97%E9%95%96%E5%B1%80%E8%83%8C%E6%99%AF.png',
        content:'面向政企的基于区块链的可信数据传输平台',
       isPlay:true
    }
  },methods:{
   async handclick(){
    await  this.$refs.video.play()
    this.isPlay=false
    },
    download(){
      window.open('https://sxdata-1325442424.cos.ap-chengdu.myqcloud.com/SZBJ_1.0.8.exe')
    }
  }
};
</script>

<style scoped>
.leftActive{
  left: 0;
   position: absolute;
    top: 0;
}
.rightActive{
  right: 0;
   position: absolute;
    top: 0;
}
.Conten-body{
  margin-top: 26px;
  font-family: Regular;
font-weight: 300;
font-size: 16px;
color: #838690;
line-height: 26px;
}
.Conten-body p{
  margin-bottom: 18px;
}
.Conten-body p:last-child{
  margin-bottom: 0px;
}
.Content-head{

  height: 32px;
  display: flex;
}
.Content-head p{
margin-left: 14px;
  height: 32px;
  line-height: 32px;
  font-family: Medium;
font-weight: 500;
font-size: 20px;
color: #17213C;
}
.item-Content{
  width: 50%;
    padding: 50px 60px 0px 60px;
   
}
.list-item{
  width: 1110px;
  height: 310px;
  position: relative;
  object-fit: cover;
  margin-bottom: 50px;
  /* background-image: url('@/assets1/数字镖局_slices/租住.png'); */

}
.list-item:last-child{
  margin-bottom: 0;
}
.Img{
  width: 140px;
  height: 140px;
}

.introduce-list{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.szbj-introduce {
  padding: 97px 0 93px 0;
  background-color: #fff;
  width: 100vw;
}

.products-List {
  display: flex;
  justify-content: center;
  text-align: center;
}
.hxcp {
  min-width: 1920px;
  padding-top: 301px;
  padding-bottom: 100px;
  background-color: #f9fbfc;
  display: flex;
  flex-direction: column;
  justify-content: center;

  text-align: center;
}
.hxcp-title {
  font-family: Medium;
font-weight: 500;
font-size: 36px;
color: #17213C;
margin-bottom: 60px;

}
.icon-a-baoxianxiangbaoguancaijing {
  color: #000;
  font-size: 52px;
}
.product-item {
  width: 380px;
  height: 380px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  text-align: center;
  padding: 10px 30px;
  position: relative;
  background-color: #fff;
  margin-right: 30px;
padding-top: 30px;
}
.product-item:last-child {
  margin-right: 0px;
}
.item-title {
  margin-top: 10px;
  font-family:Medium;
font-weight: 500;
font-size: 24px;
color: #17213C;
  margin-bottom: 12px;
}
.item-content {
font-family: Regular;
font-weight: 400;
font-size: 18px;
color: #838690;
line-height: 29px;
  letter-spacing: 1px;
}
.item-ornament {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #000;
  z-index: -1;
}

.szbj-body {
}
.icon-bofang {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 30px;
  transform: translate(-50%, -50%);
}
.video-btn {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #d5eaf7;
  border: 2px solid #fff;
  cursor: pointer;
}
.video-box {
  width: 1230px;
  height: 350px;
  display: flex;
   padding: 8px 7px;
}
.video {
  flex: 1;
  border-radius: 10px;
  margin-right: 70px;
  position: relative;
}
video {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.video-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.video-content .title {
  height: 40px;
  font-family: Medium;
font-weight: 500;
font-size: 28px;
color: #17213C;
line-height: 40px;
display: block;

}
.content {
font-family: Light;
font-weight: 300;
font-size: 20px;
  margin-bottom: 52px;
  color: #838690;
}
.download {
  font-family: Light;
font-weight: 400;
font-size: 20px;
color: #FFFFFF;
  line-height: 56px;
  text-align: center;
 width: 200px;
height: 56px;
background: #0D53FF;
border-radius: 12px;
  cursor: pointer;
  margin-right: 36px;
}
.look {
font-family: Regular;
font-weight: 400;
font-size: 20px;
color: #0D53FF;
  line-height: 56px;
  text-align: center;
  width: 200px;
height: 56px;
border-radius: 12px;
border: 2px solid #0D53FF;
  cursor: pointer;
}
.btn-list{
  display: flex;
}
</style>